import { TextInput } from '@uplift/ui-v2';
import { useProfileStyles } from '../styles';

export type PronounsFormProps = {
  hideLabel?: boolean;
};

export const PronounsForm: React.VFC<PronounsFormProps> = props => {
  const { classes } = useProfileStyles();

  return (
    <div>
      <TextInput
        label={props.hideLabel ? undefined : '(Optional)'}
        name="pronouns"
        fullWidth
        inputClasses={{ root: classes.maxWidth400 }}
      />
    </div>
  );
};
